module.exports = new Promise((resolve, reject) => {
  const remoteName = "@coremind/client-proposals-ui";
  const localOverride = "";
  const latestUrl = "https://storage.offsetmind.com/platform/modules/federated/%40coremind/client-proposals-ui/latest/remoteEntry.js";
  const manifestUrl = "https://storage.offsetmind.com/platform/modules/federated/%40coremind/client-proposals-ui/latest/manifest.json";
  const versionedBase = "https://storage.offsetmind.com/platform/modules/federated/%40coremind/client-proposals-ui/";
  const existing = document.querySelector('script[data-remote="' + remoteName + '"]');
  const initSharing = (typeof __webpack_init_sharing__ === 'function')
    ? __webpack_init_sharing__('default')
    : Promise.resolve();
  const loadScript = (remoteUrl) => new Promise((res, rej) => {
    const script = document.createElement('script');
    script.src = remoteUrl;
    script.type = 'text/javascript';
    script.async = true;
    script.dataset.remote = remoteName;
    script.onload = () => {
      const container = window[remoteName];
      if (!container) return rej(new Error('Missing remote container for ' + remoteName));
      res(container);
    };
    script.onerror = () => rej(new Error('Failed to load ' + remoteName + ' from ' + remoteUrl));
    document.head.appendChild(script);
  });
  initSharing.then(() => {
    const shareScope = (typeof __webpack_share_scopes__ !== 'undefined') ? __webpack_share_scopes__.default : undefined;
    const wrap = (container) => resolve({
      get: (request) => container.get(request),
      init: (arg) => { try { return container.init(arg || shareScope); } catch (e) { return undefined; } }
    });
    if (existing && window[remoteName]) return wrap(window[remoteName]);
    if (localOverride) return loadScript(localOverride).then(wrap, reject);
    fetch(manifestUrl, { cache: 'no-store' })
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error('no manifest'))))
      .then((manifest) => loadScript(versionedBase + manifest.version + '/remoteEntry.js'))
      .catch(() => loadScript(latestUrl))
      .then(wrap, reject);
  });
});